import React, { Component } from 'react';
import './DetailStyle.css'
import ProductImage from './ProductImage';

class ProductDetails extends Component {


    constructor(props) {
        super(props);
        this.state = {
            price: 450.00,
            qty: 1
        }
    }


    inc = () => {
        this.setState({
            qty: this.state.qty + 1
        })
    }

    dec = () => {
        this.setState({
            qty: this.state.qty === 1 ? 1 : this.state.qty - 1
        })
    }

    textChange = (e) => {

        if (e.target.value) {
            let q = parseInt(e.target.value);

            this.setState({
                qty: q < 1 ? 1 : q
            })
        }

    }

    render() {
        return (
            <div className="container">
                <div className="card-group">
                    <div className="card border-main">
                        {/* <img src={require('../../images/home/main2.jpg')} /> */}
                        <ProductImage />
                    </div>
                    <div className="card border-main">
                        <br /><br />
                        <h1 className="text-center txt-main strong" >
                            Sri Lankan Orchid
                        </h1>
                        <div className="container" align="center">
                            <div className="small-box" style={{ padding: '20px' }}>
                                <p className="txt-main border-white"> Lorem ipsum, dolor sit amet consectetur adipisicing elit. Iusto optio adipisci qui rem ea, repellat labore aliquam consequuntur hic. Nam blanditiis nesciunt facilis obcaecati, ullam saepe quaerat consequuntur. Minus, aperiam.</p>
                            </div>

                            <div className="small-box bg-main w-50 main-shadow">
                                <h5 className="text-white">Unit Price</h5>
                                <h5 className="text-white">Rs.{`${this.state.price}`}.00</h5>
                            </div>
                            <div className="small-box  w-50">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <button
                                            onClick={this.dec}
                                            className="btn inc-button" type="button" id="button-addon1">-</button>
                                    </div>
                                    <input
                                        style={{ height: '50px', fontSize: '28px', textAlign: 'center' }}
                                        type="text" className=" form-control"
                                        onChange={this.textChange}
                                        value={this.state.qty} />
                                    <div className="input-group-append">
                                        <button
                                            onClick={this.inc}
                                            className="btn inc-button" type="button" id="button-addon2">+</button>
                                    </div>
                                </div>
                            </div>

                            <div className="small-box bg-main w-50 main-shadow">
                                <h5 className="text-white">Total Price</h5>
                                <h4 className="text-white">Rs.{`${this.state.price * this.state.qty}`}.00</h4>

                            </div>

                            <br />
                            <button class="btn inc-button"
                                onClick={() => {
                                    window.location.href = "/cart"
                                }}
                            ><i className="fa fa-shopping-cart"></i> Add to Cart</button>
                            <br /><br />
                        </div>


                    </div>
                </div>
            </div>

        );
    }
}

export default ProductDetails;
